import React, { useRef, useEffect } from 'react';
import {
  Box,
  Flex,
  VStack,
  Heading,
  Text,
  Input,
  Textarea,
  Button,
  Image,
  Link,
  Container,
  FormControl,
  FormLabel,
  FormHelperText,
  useColorModeValue, useToast
} from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import planeBg from '../../assets/plane.webp';
import emailjs from '@emailjs/browser';
import AppointmentScheduler from './AppointmentScheduler';

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
  100% { transform: translateY(0px); }
`;


const ContactPage = () => {

  const bgColor = useColorModeValue('white', 'gray.800');
  const form = useRef();
  const toast = useToast();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_htf658s',
      'template_z49o7i7',
      form.current,
      'ttlgYzWWOZlOIFWcU'
    )
      .then((result) => {
        console.log(result.text);
        toast({
          title: 'Message sent successfully!',
          status: 'success',
          duration: 4000,
          isClosable: true,
        });
        form.current.reset();
      }, (error) => {
        console.log(error.text);
        toast({
          title: 'Failed to send message.',
          status: 'error',
          duration: 4000,
          isClosable: true,
        });
      });
  };


  return (
    <Box py={16} px={6} id="contact">
      <Container maxW="7xl">
        <Flex
          direction={{ base: 'column', md: 'row' }}
          bg={"#61718c50"}
          borderRadius="20px"
          // boxShadow="lg"
          p={{ base: 6, md: 10 }}
          gap={10}
        >
          {/* Left Side */}
          <VStack flex="1" spacing={4} textAlign="center" data-aos="fade-up" >
            <Heading textTransform="" color="blue.200" size="lg">
              Contact us
            </Heading>
            <Text color={'white.600'} fontSize="lg" maxW="500px">
              Or reach out manually to{' '}
              <Link href="mailto:dremotechsolutions@gmail.com" color="teal.400">
                dremotechsolutions@gmail.com
              </Link>
            </Text>
            <Image
              src={planeBg}
              alt="Plane illustration"
              display={{ base: 'none', md: 'block' }}
              pt={6}
              w={{ base: 'full', md: '50%' }}
              maxW="400px"
              borderRadius="lg"
              animation={`${float} 3s ease-in-out infinite`}
            />
          </VStack>
          {/* <AppointmentScheduler /> */}

          {/* Right Side */}
          <VStack as="form" ref={form} onSubmit={sendEmail} flex="1" spacing={5} color={'white.800'} data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"  data-aos-delay="200" >



            <FormControl isRequired>
              <FormLabel>Email address</FormLabel>
              <Input type="email" name="email" placeholder="you@example.com" />
              <FormHelperText color="blue.500">
                We'll never share your email.
              </FormHelperText>
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Your Name</FormLabel>
              <Input type="text" name="name" placeholder="Your name" />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Your Message</FormLabel>
              <Textarea name="message" placeholder="Type your message..." rows={4} />
            </FormControl>

            <Button
              type="submit"
              colorScheme="blue"
              size="lg"
              w={{ md: "30%", base: "50%" }}
              alignSelf={"flex-start"}
              borderRadius="lg"
            >
              Send Message
            </Button>
          </VStack>
        </Flex>

        {/* Google Map Embed */}
        {/* Map Section */}
        <Box
          mt={16}
          py={10}
          px={6}
          borderRadius="20px"
          // bg={useColorModeValue("gray.100", "gray.700")}
          boxShadow="lg"
        >
          <VStack spacing={4} textAlign="center" mb={6}>
            <Heading
              as="h3"
              size="lg"
              color={useColorModeValue("blue.300", "blue.300")}
            >
              📍 Find Us on the Map
            </Heading>
            <Text fontSize="md" color={useColorModeValue("gray.300", "gray.300")} maxW="3xl">
              we're always ready to discuss your ideas over coffee or a Zoom call.
            </Text>
          </VStack>

          <Box borderRadius="20px" overflow="hidden" boxShadow="xl" data-aos="zoom-in">
            <iframe
              title="Dremotech Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31566.675324162487!2d77.00300188996421!3d8.515452750554646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b05b0a457dee771%3A0x107a5751ad95268a!2sPeyad%2C%20Kerala!5e0!3m2!1sen!2sin!4v1746823397847!5m2!1sen!2sin"
              // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3945.686056919415!2d77.01819467474539!3d8.529828596603394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8eab4060b5ba473%3A0x182fb4dffd6729c8!2sDremotech%20Solutions!5e0!3m2!1sen!2sin!4v1746823258679!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Box>
        </Box>

      </Container>
    </Box>
  );
};

export default ContactPage;
